var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkadayLogoMain2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 171.45583 90.336494",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cc3300",
      fillOpacity: 1,
      strokeWidth: 0.183192
    },
    id: "rect1164-5-8-1-7",
    width: 3.1827171,
    height: 41.641426,
    x: -64.952286,
    y: 110.38156,
    transform: "matrix(-0.00943405,-0.9999555,0.99999416,-0.0034164,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cc3300",
      fillOpacity: 1,
      strokeWidth: 0.11659
    },
    id: "rect1164-5-8-1-7-2",
    width: 3.1825988,
    height: 16.867434,
    x: -65.073914,
    y: 42.551022,
    transform: "matrix(-0.00382142,-0.9999927,0.99996443,-0.00843423,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cc3300",
      fillOpacity: 1,
      strokeWidth: 0.11659
    },
    id: "rect1164-5-8-1-7-2-4",
    width: 3.1825988,
    height: 16.867434,
    x: -65.156555,
    y: 74.294968,
    transform: "matrix(-0.00382142,-0.9999927,0.99996443,-0.00843423,0,0)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "10.5833px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    x: 31.207655,
    y: 50.663277,
    id: "text2768"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan2766",
    style: {
      strokeWidth: 0.264583
    },
    x: 31.207655,
    y: 50.663277
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    x: 88.245537,
    y: 64.515343,
    id: "text6886"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan6884",
    style: {
      fontSize: "25.4px",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    x: 88.245537,
    y: 64.515343
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "22.5778px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    x: 25.096457,
    y: 47.811378,
    id: "text12070"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan12068",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    x: 25.096457,
    y: 47.811378
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "22.5778px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    x: 30.392832,
    y: 45.774315,
    id: "text14802"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14800",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.264583
    },
    x: 30.392832,
    y: 45.774315
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "45.8611px",
      lineHeight: 1.25,
      fontFamily: "'Arial Rounded MT Bold'",
      InkscapeFontSpecification: "'Arial Rounded MT Bold, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 0.010143368,
    y: 57.589317,
    id: "text16918"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16916",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "45.8611px",
      fontFamily: "'Arial Rounded MT Bold'",
      InkscapeFontSpecification: "'Arial Rounded MT Bold, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 0.010143368,
    y: 57.589317
  }, "W")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "31.75px",
      lineHeight: 1.25,
      fontFamily: "'Arial Rounded MT Bold'",
      InkscapeFontSpecification: "'Arial Rounded MT Bold, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 41.232044,
    y: 57.774376,
    id: "text18031"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan18029",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "31.75px",
      fontFamily: "'Arial Rounded MT Bold'",
      InkscapeFontSpecification: "'Arial Rounded MT Bold, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 41.232044,
    y: 57.774376
  }, "orkaday")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkadayLogoMain2);
export default __webpack_public_path__ + "static/media/workadayLogoMain2.9bada0b132a4e77abddc634610582bb7.svg";
export { ForwardRef as ReactComponent };